import React from 'react';

import t from '../../lib/I18n';

import Icon from '../general/Icon';

export default function SmartcardBenefits() {
    const getBenefitText = num => {
        const key = `account.smartcardsignup.benefit${num}`;
        const text = t(key);
        if (text === key) {
            return null;
        }
        return text;
    };
    const benefits = [1, 2, 3, 4, 5].map(getBenefitText).filter(Boolean);
    const count = benefits.length;

    const classes = `smartcard-signup__benefits smartcard-signup__benefits-count-${count}`;
    return (
        <ul className={classes}>
            {benefits.map(benefit => (
                <li key={benefit}>
                    <Icon inline icon="tick" />
                    &nbsp;
                    {benefit}
                </li>
            ))}
        </ul>
    );
}



// WEBPACK FOOTER //
// ./src/components/login/SmartcardBenefits.js